/**
 * Discount exclusion configuration.
 *
 * Products listed here will display an exclusion message on the PDP.
 *
 * To exclude a product, add its numeric product ID to the relevant range below.
 * Each range is a named grouping for readability — all ranges are merged into a
 * single lookup set at runtime.
 *
 * Example:
 *   const SUMMER_COLLAB_RANGE = [123456, 789012];
 */

// ---------------------------------------------------------------------------
// Define excluded ranges here
// ---------------------------------------------------------------------------

const TOLU_COKER_RANGE = [
  151965275, 151965406, 151965420, 151965271, 152191665, 155173871, 155173869,
  152936151, 152936152, 151528885, 151639012, 151701439, 151669147, 151669158,
  151669618, 151451277, 151451321, 151451278, 153280356,
];

const ALL_EXCLUDED_RANGES: readonly number[][] = [TOLU_COKER_RANGE];

// ---------------------------------------------------------------------------
// Merged lookup set — do not edit below this line
// ---------------------------------------------------------------------------

export const DISCOUNT_EXCLUDED_PRODUCT_IDS = new Set<number>(
  ALL_EXCLUDED_RANGES.flat(),
);

// ---------------------------------------------------------------------------
// Per-product purchase quantity limits
//
// Products listed here cannot be added to the bag beyond the specified limit.
// The limit is enforced client-side only.
//
// Example:
//   export const PRODUCT_QUANTITY_LIMITS: Record<number, number> = {
//     123456: 2,
//   };
// ---------------------------------------------------------------------------

export const PRODUCT_QUANTITY_LIMITS: Record<number, number> =
  Object.fromEntries(TOLU_COKER_RANGE.map((id) => [id, 2]));
